import React from "react";
import { useTable, useSortBy, Column } from "react-table";
import { ButtonWithoutIcon, CustomPagination } from "../../lib";
import { KTIcon } from "../../../../../_metronic/helpers";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";

interface Fan {
  id: number;
  name: string;
  firstName: string | null;
  lastName: string | null;
  national_code: string;
  mobile: string;
  created_at: string;
  updated_at: string;
  male: boolean;
  national_code_verified_at: string | null;
  status?: boolean;
  actions?: any;
}

interface TableProps {
  data: {
    attendees: Fan[];
    totalRows: number;
  };
  queryString: {
    page: number | string;
    search: string;
    numberInPage: number | string;
  };
  setQueryString: (page: number) => void;
  refetch: () => void;
  numberInPage: number;
}

const FansReportTable = ({
  data,
  queryString,
  setQueryString,
  refetch,
  numberInPage,
}: TableProps) => {
  const navigate = useNavigate();

  const columns = React.useMemo<Column<Fan>[]>(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        accessor: "id",
        Cell: ({ row }) => (
          <span className="rowNum">
            {(Number(queryString.page) - 1) * Number(numberInPage) + row.index + 1}
          </span>
        ),
      },
      {
        Header: <HeaderTextIcon text={"نام و نام خانوادگی"} />,
        accessor: "name",
      },
      {
        Header: <HeaderTextIcon text={"کد ملی"} />,
        accessor: "national_code",
      },
      {
        Header: <HeaderTextIcon text={"موبایل"} />,
        accessor: "mobile",
      },
      {
        Header: <HeaderTextIcon text={"تاریخ ثبت نام"} />,
        accessor: "created_at",
        Cell: ({ value }) => <span>{moment(value).format('jYYYY/jMM/jDD HH:mm')}</span>,
      },
      {
        Header: <HeaderTextIcon text={"جنسیت"} />,
        accessor: "male",
        Cell: ({ value }) => (
          <span>
            {value ? 'آقا' : 'خانم'}
          </span>
        ),
      },
      {
        Header: "",
        accessor: "actions",
        Cell: ({ row }) => (
          <div className={"d-flex gap-3 justify-content-center"}>
            <ButtonWithoutIcon
              btnText={"جزئیات"}
              type={"click"}
              onClick={() => {
                navigate("/reports/fans-log-all-match", { 
                  state: { 
                    nationalCode: row.original.national_code
                  }
                });
              }}
            />
          </div>
        ),
      },
    ],
    [queryString.page, numberInPage, navigate]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data: data.attendees || [],
    },
    useSortBy
  );

  return (
    <div className={"p-c-30"}>
      <div style={{ overflow: "auto" }}>
        <table
          {...getTableProps()}
          className="table align-middle table-row-dashed fs-6 gy-5"
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end mt-5">
        <CustomPagination
          activePage={Number(queryString.page)}
          setQueryString={setQueryString}
          totalRows={data?.totalRows}
          numberInPage={numberInPage}
        />
      </div>
    </div>
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => (
  <div className={"d-flex align-items-center justify-content-center gap-2"}>
    <span>{text}</span>
    <KTIcon iconName={"filter"} className={"fs-5"} />
  </div>
);

export default FansReportTable; 